/**
 * Returns true when every reference with calculationType "hourly" has isApproved set to true.
 * References with other calculation types are ignored.
 */
export function getAllHourlyReferencesApproved<
	T extends { isApproved: boolean; calculationType: string },
>(references: T[]): boolean {
	if (references.length === 0) return false;
	const hourly = references.filter((r) => r.calculationType === "hourly");
	return hourly.every((r) => r.isApproved);
}
